import { childSelectionPointToBlockOffset } from "./util.child-selection-point-to-block-offset.js";
import { isKeyedSegment } from "./util.slice-blocks.js";
function getSelectionEndPoint(selection) {
  return selection ? selection.backward ? selection.anchor : selection.focus : null;
}
function getSelectionStartPoint(selection) {
  return selection ? selection.backward ? selection.focus : selection.anchor : null;
}
function isSelectionCollapsed(selection) {
  return selection ? JSON.stringify(selection.anchor.path) === JSON.stringify(selection.focus.path) && selection.anchor.offset === selection.focus.offset : !1;
}
function selectionPointToBlockOffset({
  context,
  selectionPoint
}) {
  return selectionPoint.path.length === 1 && isKeyedSegment(selectionPoint.path[0]) ? {
    path: [{
      _key: selectionPoint.path[0]._key
    }],
    offset: selectionPoint.offset
  } : childSelectionPointToBlockOffset({
    context,
    selectionPoint
  });
}
export {
  getSelectionEndPoint,
  getSelectionStartPoint,
  isSelectionCollapsed,
  selectionPointToBlockOffset
};
//# sourceMappingURL=util.selection-point-to-block-offset.js.map
